import 'core-js/stable';
import React from 'react';
import './index.scss';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { SnackbarProvider } from 'notistack';
import { createMuiTheme, IconButton, ThemeProvider } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import { Provider } from 'react-redux';
import Loading from 'components/loading/Loading';
import twLocale from 'date-fns/locale/zh-TW';
import zhTW from 'components/NewTable/zhTW';
import indexRouter from './router';
import { warningSnack } from './main_consts';
import store from './reducers/configureStore';

const theme = createMuiTheme({}, zhTW);
// const history = createBrowserHistory();
let notistackRef: SnackbarProvider;
ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={twLocale}>
        <SnackbarProvider
          {...warningSnack}
          maxSnack={3}
          iconVariant={{
            success: <CheckCircleIcon style={{ paddingRight: '3px' }} />,
            error: <CancelIcon style={{ paddingRight: '3px' }} />,
            warning: <WarningIcon style={{ paddingRight: '3px' }} />,
            info: <InfoIcon style={{ paddingRight: '3px' }} />,
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          autoHideDuration={6000}
          ref={(ref) => {
            notistackRef = ref as SnackbarProvider;
          }}
          action={(key) => (
            <IconButton
              onClick={() => notistackRef.closeSnackbar(key)}
              color="inherit"
            >
              <CloseIcon />
            </IconButton>
          )}
        >
          <Loading />
          <BrowserRouter>
            <Switch>
              {indexRouter.map((prop) => {
                return (
                  <Route
                    key={prop.path}
                    path={prop.path}
                    component={prop.component}
                  />
                );
              })}
            </Switch>
          </BrowserRouter>
        </SnackbarProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
